var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_16263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.623047H1.77187C0.792187 0.623047 0 1.39648 0 2.35273V22.8887C0 23.8449 0.792187 24.623 1.77187 24.623H22.2234C23.2031 24.623 24 23.8449 24 22.8934V2.35273C24 1.39648 23.2031 0.623047 22.2234 0.623047ZM7.12031 21.0746H3.55781V9.61836H7.12031V21.0746ZM5.33906 8.05742C4.19531 8.05742 3.27188 7.13398 3.27188 5.99492C3.27188 4.85586 4.19531 3.93242 5.33906 3.93242C6.47813 3.93242 7.40156 4.85586 7.40156 5.99492C7.40156 7.1293 6.47813 8.05742 5.33906 8.05742ZM20.4516 21.0746H16.8937V15.5059C16.8937 14.1793 16.8703 12.4684 15.0422 12.4684C13.1906 12.4684 12.9094 13.9168 12.9094 15.4121V21.0746H9.35625V9.61836H12.7687V11.184H12.8156C13.2891 10.284 14.4516 9.33242 16.1813 9.33242C19.7859 9.33242 20.4516 11.7043 20.4516 14.7887V21.0746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_16263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.623047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f39c537f901ddafbd07d83d5f2b8e4ce.svg";
export { ForwardRef as ReactComponent };